import { createAsyncThunk } from '@reduxjs/toolkit';
import { closeClientPortalChats } from 'services/pod';

export const ThunkCloseClientPortalChat = createAsyncThunk<number, number, { rejectValue: Error }>(
  'clientPortalChats/closeClientPortal',
  async (id, { rejectWithValue }) => {
    try {
      await closeClientPortalChats(id);
      return id;
    } catch (error) {
      const { data } = error as {
        data: Error;
      };
      return rejectWithValue(data);
    }
  },
);
